import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../../Config";
import Loading from "../../../Components/Loading";
import Table from "../../../Components/Properties/Lease/TableForExpiring";
import { toast } from "react-toastify";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
} from "../../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Kyc from "../../../Components/Tenants/Kyc";
import moment from "moment";
import UploadDocument from "../../../Components/Tenants/UploadDocument";
import NotFoundModel from "../../../Components/NotFoundModel";
import { SummarySkeletonLoading } from "../../../Components/SkeletonLoading";
import SummaryCard from "../../../Components/Properties/Lease/SummaryCardForExpiring";

const AgreementExpiring = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [isFocused, setIsFocused] = useState(false);

  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [filter, setFilter] = useState("");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [openKYCModel, setOpenKYCModel] = useState(false);
  const [apiData, setApiData] = useState();
  const [masterData, setMasterData] = useState();
  const [isRenewAgreement, setIsRenewAgreement] = useState(false);

  const [summaryData, setSummaryData] = useState({
    totalMovedOut: 0,
    curMonthMovedOut: 0,
    defaulters: 0,
    totalDefaultedDues: 0,
  });
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();
  const query = `propId=${property?.id}&searchVal=&filter=${filter}&platform=3`;

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/landlord/web/agreement-expiring?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === true) {
      setApiData(res?.list);
      setSummaryData(res?.stats);
      setMasterData(res?.list);
      // if (isFocused === false) setSummaryData(res?.stats);
      setIsFocused(true);
    } else {
      error = true;
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    isFetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (filter && !isFirstTime && !isFetching && !isRefetching && !isLoading) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 200);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [filter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
      setIsFirstTime(false);
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, [property]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getListMutate();
  };

  // --------Upload Document---------
  const uploadDocumentFunction = async (values) => {
    const formData = new FormData();
    formData.append("clientId", values.id);
    formData.append("document", values.tenantDocumentImage);

    return await axios.post(`${Config.apiUrl}/uploadDocument`, formData, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadDocumentSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Document uploaded successfully!");
      apiData((prevData) =>
        prevData.map((owner) =>
          owner.id === selectedData.id
            ? { ...owner, documentPath: data.data.documentPath }
            : owner
        )
      );
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
    setUploadDocument(false);
    setSelectedData("");
  };

  const onUploadDocumentError = (error) => {
    toast.error(error?.response?.data?.msg || "An error occurred.");
    setUploadDocument(false);
  };
  const { isLoading: uploadDocumentLoading, mutate: uploadDocumentMutate } =
    useMutation(uploadDocumentFunction, {
      onSuccess: onUploadDocumentSuccess,
      onError: onUploadDocumentError,
    });

  const onSummaryBoxClick = (data) => {
    sessionStorage.removeItem("landlord_expiring_page");
    let filteredData;
    const currentDate = moment().startOf("day");

    if (data === "ECM") { //Expiring Current Month
      const startOfMonth = currentDate.clone().startOf("month").format("YYYY-MM-DD");
      const endOfMonth = currentDate.clone().endOf("month").format("YYYY-MM-DD");
      filteredData = masterData.filter((leaseData) => {
        if (!leaseData.endDate) return false;

        const expiryDate = moment(leaseData.endDate);
        return expiryDate.isBetween(startOfMonth, endOfMonth, null, "[]");
      });
    } else if (data === "ENM") { //Expiring Next Month
      const startOfNextMonth = currentDate
        .clone()
        .add(1, "months")
        .startOf("month");
      const endOfNextMonth = currentDate
        .clone()
        .add(1, "months")
        .endOf("month");

      filteredData = masterData.filter((leaseData) => {
        if (!leaseData.endDate) return false;

        const expiryDate = moment(leaseData.endDate);
        return expiryDate.isBetween(
          startOfNextMonth,
          endOfNextMonth,
          null,
          "[]"
        );
      });
    } else if (data === "E") {
      filteredData = masterData.filter((leaseData) => {
        if (!leaseData.endDate) return false;

        const expiryDate = moment(leaseData.endDate);
        return expiryDate.isBefore(currentDate);
      });
    } else {
      filteredData = masterData;
    }
    setApiData(filteredData);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Lease Expiring
            <Underline />
          </BoxTitle>
        </BoxHead>

        {uploadDocument && (
          <UploadDocument
            uploadDocumentMutate={uploadDocumentMutate}
            uploadDocumentLoading={uploadDocumentLoading}
            setUploadDocument={setUploadDocument}
            selectedData={selectedData}
            data={data?.data}
          />
        )}

        {openKYCModel && (
          <Kyc setOpenKYCModel={setOpenKYCModel} selectedData={selectedData} />
        )}

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={3} />
        )}
        {isFocused && apiData && (
          <SummaryCard summaryData={summaryData} onClick={onSummaryBoxClick} />
        )}

        {!error && !isLoading && apiData && (
          <TableWrapper>
            <Table
              apiData={error ? [] : apiData?.length > 0 ? apiData : []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              //setEditUser={setEditUser}
              setViewDetail={setViewDetail}
              setUploadDocument={setUploadDocument}
              userType={user.userType}
              setOpenKYCModel={setOpenKYCModel}
              setIsRenewAgreement={setIsRenewAgreement}
            />
            {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"All good! No leases are expiring."} />}
          </TableWrapper>
        )}
        {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`my-8 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;
// export const FieldWrapper = tw.div`
// ${(p) => (p.$select ? "" : "pl-2  field-wrapper border border-gray-300")}
//  relative  rounded-md   w-full  flex items-center`;
const FilterContainer = tw.div`
grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color py-[.550rem] text-sm`;
export default AgreementExpiring;
